// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as React from "react";
import * as Timestamp$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as CardComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardComponent.bs.js";
import * as TableComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableComponent.bs.js";
import * as ReasonReactUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ReasonReactUtils.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";
import * as FetchLoadableViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/FetchLoadableViewMapper.bs.js";

function getColumnSchema(param) {
  return {
          hd: {
            column: {
              TAG: /* Text */0,
              _0: "Start Date"
            },
            accessor: (function (incentive) {
                return {
                        TAG: /* Text */0,
                        _0: Timestamp$Catalyst.toString(incentive.start_date, "DD MMM YYYY")
                      };
              })
          },
          tl: {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "Campaign ID"
              },
              accessor: (function (incentive) {
                  return {
                          TAG: /* Text */0,
                          _0: incentive.campaign_id
                        };
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Text */0,
                  _0: "Incentive Parameters"
                },
                accessor: (function (incentive) {
                    return {
                            TAG: /* Custom */5,
                            _0: (function (param) {
                                return React.createElement("div", undefined, "Completed trips: " + String(incentive.completed_trips), React.createElement("br", undefined), "ABRTG allowed: " + String(incentive.abrtg_allowed), React.createElement("br", undefined), "Missed order allowed: " + String(incentive.missed_order_allowed), React.createElement("br", undefined), "Fraud allowed: " + String(incentive.fraud_allowed));
                              })
                          };
                  })
              },
              tl: /* [] */0
            }
          }
        };
}

function getView(incentives) {
  return React.createElement(FetchLoadableViewMapper$Catalyst.make, {
              loadableData: incentives,
              children: (function (incentivesList) {
                  if (List.length(incentivesList) === 0) {
                    return React.createElement(ErrorDisplayComponent$Catalyst.make, {
                                error: ErrorUtils$Catalyst.getDefaultErrorEntity("No incentives for the partner", undefined, undefined)
                              });
                  } else {
                    return React.createElement(CardComponent$Catalyst.make, {
                                children: React.createElement(TableComponent$Catalyst.make, {
                                      columns: getColumnSchema(undefined),
                                      rowData: ReasonReactUtils$Catalyst.sliceList(incentivesList, undefined, 5),
                                      className: "order-table"
                                    })
                              });
                  }
                })
            });
}

export {
  getColumnSchema ,
  getView ,
  
}
/* react Not a pure module */
